import React, { useEffect, useState } from "react";
import api from "../../api/axios";

export default function PageImageSelector({ pageKey, value, onChange }) {
  // props:
  //   • pageKey: "about-us" or "contact" etc.
  //   • value: the currently selected URL (string)
  //   • onChange: callback(newUrl)
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!pageKey) return;
    setLoading(true);
    api
      .get(`/page-images?key=${encodeURIComponent(pageKey)}`)
      .then((res) => {
        setImages(res.data);
      })
      .catch((err) => {
        console.error("Failed to fetch page images:", err);
      })
      .finally(() => setLoading(false));
  }, [pageKey]);

  if (loading) {
    return <p>Loading images…</p>;
  }

  return (
    <select
      className="text-primary w-full px-3 py-2 border rounded"
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="">— Select an image —</option>
      {images.map((img) => (
        <option key={img._id} value={img.url}>
          {img.filename}
        </option>
      ))}
      <option value="__upload_new__">+ Upload new…</option>
    </select>
  );
}
